
import { getValidationIcon, getValidationIconColor, getValidationColor } from './validationUtils';
import { ImportResult } from './types';

interface ValidationDetailsProps {
  details: ImportResult['details'];
}

export const ValidationDetails = ({ details }: ValidationDetailsProps) => {
  if (!details || details.length === 0) return null;

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-medium text-gray-700">Vérification des annonces importées :</h4>
      <div className="max-h-60 overflow-y-auto space-y-2">
        {details.map((detail, index) => {
          const ValidationIcon = getValidationIcon(detail.validation_status);
          const iconColor = getValidationIconColor(detail.validation_status);
          const cardColor = getValidationColor(detail.validation_status);

          return (
            <div key={index} className={`p-3 rounded border ${cardColor}`}>
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-1">
                    <ValidationIcon className={`h-4 w-4 ${iconColor}`} />
                    <span className="font-medium text-sm truncate">{detail.title}</span>
                  </div>
                  <div className="text-xs space-y-1">
                    <p><span className="font-medium">Prix:</span> {detail.price}€</p>
                    <p><span className="font-medium">Photos:</span> {detail.images_count} image(s)</p>
                    <p><span className="font-medium">Description:</span> {detail.description.substring(0, 50)}...</p>
                  </div>
                  {detail.issues && detail.issues.length > 0 && (
                    <div className="mt-2">
                      <p className="text-xs font-medium text-red-600">Problèmes détectés :</p>
                      <ul className="text-xs text-red-600 list-disc list-inside">
                        {detail.issues.map((issue, issueIndex) => (
                          <li key={issueIndex}>{issue}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
